<template>
  <div class="box album">
    <div class="al1">
      <div class="min_box">
        <div class="al_top">
          <div class="at_pic"><img :src="obj.url" alt="" /></div>
          <div class="at_box">
            <p>{{ obj.title }}</p>
            <div>{{ obj.describe }}</div>
            <span>{{ obj.time }}</span>
          </div>
        </div>
      </div>
    </div>
    <div class="al2">
      <!-- pc瀑布流 -->
      <div v-if="!isM" class="wfll">
        <ul>
          <transition-group name="list" tag="li">
            <li
              v-for="(item, index) in waterfallList"
              :key="index"
              class="will_li"
              @click="lookBigPic(item, index)"
            >
              <div class="will_img"><img :src="item.url" /></div>
              <p>{{ item.title }}</p>
            </li>
          </transition-group>
        </ul>
      </div>
      <p class="bottom_line" v-if="show && !isM">- 到底啦 -</p>

      <!-- M 瀑布流 -->
      <div v-if="isM" class="waterfall">
        <div
          class="item"
          v-for="(item, index) in waterfallList"
          :key="index"
          @click="lookBigPic(item, index)"
          :id="index"
        >
          <img :src="item.url" />
        </div>
      </div>
      <p class="bottom_line" v-if="show&&isM">- 到底啦 -</p>
    </div>
    <Loading :show="!show && loading" />

    <!-- 查看大图 -->
    <Cbigpic
      :dialog="dialog"
      :picArr="waterfallList"
      v-on:dialog="changeDialog($event)"
      ref="cbigpicref"
    />
  </div>
</template>
<script>
import { getPhotoList } from "@/api/all";
import Loading from "@/components/loading";
import Cbigpic from "@/components/cbigpic"; //查看大图
export default {
  name: "Waterfall",
  components: {
    Cbigpic,
    Loading,
  },
  data() {
    return {
      picUrl: this.$root.picUrl,
      picId: 0,
      waterfallList: [],
      waterfallCol: 5,
      colWidth: 236,
      marginRight: 10,
      marginBottom: 50,
      colHeights: [],
      data: {
        album_id: "",
        page: 1,
        limit: 5,
      },
      loading: false,
      show: false,
      obj: {},
      dialog: false,
      isM: false,
      nowTop: 0,
    };
  },
  created() {
    this.isM = JSON.parse(sessionStorage.getItem("isM"));
    this.picId = this.$route.query.id;
    this.data.album_id = this.$route.query.id;
    this.obj = this.$route.query;
    if (this.isM == true) {
      this.loadImgsm();
      window.addEventListener("scroll", this.onScrollm);
    }
  },
  mounted() {
    if (this.isM == false) {
      this.loadImgs();
    }
  },
  methods: {
    loadImgsm() {
      this.loading = true;
      getPhotoList(this.data).then((res) => {
        this.loading = false;
        if (res.data.length == 0) {
          this.show = true;
          return false;
        }

        this.waterfallList = this.waterfallList.concat(res.data);
      });
    },
    loadImgs() {
      this.loading = true;
      // 从api获取数据
      getPhotoList(this.data).then((res) => {
        if (res.data.length == 0) {
          this.show = true;
          return false;
        }

        let images = res.data;
        let promiseAll = [],
          imgs = [],
          total = images.length;

        for (let i = 0; i < total; i++) {
          promiseAll[i] = new Promise((resolve) => {
            imgs[i] = new Image();
            imgs[i].src = images[i].url;
            imgs[i].onload = () => {
              let imgData = {};
              imgData.height = (imgs[i].height * this.colWidth) / imgs[i].width;
              imgData.width = this.colWidth;
              imgData.url = images[i].url;
              imgData.title = images[i].title;
              this.waterfallList.push(imgData);
              this.rankImgs(imgData);
              resolve(imgs[i]);
            };
          });
        }
        Promise.all(promiseAll).then(() => {
          this.loading = false;
          this.loadMore();
        });
      });
    },
    loadMore() {
      setTimeout(() => {
        this.data.page++;
        this.loadImgs();
      }, 200);
    },
    rankImgs(imgData) {
      let min = this.filterMin();
      imgData.top = min.minHeight + 60;
      imgData.left = min.minIndex * (this.colWidth + this.marginRight);
      this.colHeights[min.minIndex] += imgData.height + this.marginBottom;
    },
    filterMin() {
      let minHeight = Math.min.apply(null, this.colHeights);
      return {
        minHeight: minHeight,
        minIndex: this.colHeights.indexOf(minHeight),
      };
    },
    onScrollm() {
      let scrolltop =
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        window.pageYOffset;

      if (
        (scrolltop + document.documentElement.clientHeight >=
          document.documentElement.scrollHeight - 313) &
        !this.show
      ) {
        this.data.page++;
        this.loadImgsm();
      }
    },
    onScroll() {
      this.loadMore();
    },
    //停止页面滚动
    stopMove() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "hidden";
      document.addEventListener("touchmove", m, { passive: false });
    },
    //开启页面滚动
    Move() {
      let m = function (e) {
        e.preventDefault();
      };
      document.body.style.overflow = "";
      document.removeEventListener("touchmove", m, { passive: true });
    },
    lookBigPic(item, idx) {
      this.$refs.cbigpicref.gotData({
        idx: idx,
      });
      this.dialog = true;
      // this.stopMove();
    },
    changeDialog: function (msg) {
      this.dialog = msg;
      // this.Move();
    },
  },
  beforeDestroy() {
    window.removeEventListener("scroll", this.onScrollm, false);
  },
};
</script>

<style lang="scss" scoped>
// ul li {
//   font-size: 16px;
//   color: #666666;
// }

// .wf-wrap {
//   position: relative;
//   width: 100%;
//   height: 100%;
//   min-height: 100vh;
//   background: #fff;
//   overflow-y: scroll;
//   overflow-x: hidden;
// }
// .wf-item {
//   position: absolute;
//   cursor: pointer;
// }
// .wf-item img {
//   width: 100%;
//   height: 100%;
// }
// .list-enter-active,
// .list-leave-active {
//   transition: all 1s;
// }
// .list-enter, .list-leave-to
// /* .list-leave-active for below version 2.1.8 */ {
//   opacity: 0;
//   transform: translateY(30px);
// }
</style>




// WEBPACK FOOTER //
// src/views/alldetails/album.vue